<template>

	<div>



		<div class="calendar_view_top">
			
			<h2><strong>{{ displayMonth }}</strong> {{ displayYear }}</h2>

			<div class="week_pager">
				<button class="prev_week" @click.prevent="prevWeek()"><</button>
				<span>{{ displayWeek }}</span>
				<button class="next_week" @click.prenvet="nextWeek()" >></button>
			</div>

		</div>

		<div class="calendar_week_view_container">

			<div class="week_overflow" :id="wrapperId" >
				
				<div class="week_container">


				
					<div v-for='day in allWeek' class="day_column">
						<div class="top">
							<strong>{{ displayDayName(day) }}</strong>
							<small :class="{'today' : isToday(day) }" >{{ displayDayNum(day) }}</small>
						</div> 
							
						<ul class="event_list">
					
						
									
							<li v-for='event in displayDayEvents(day)'>
								<div class="event_box">
								   <div class="inside">
								     <OneEvent :event='event' :showTime='true' :longTitle='false'></OneEvent>
								   </div>
								</div>
							</li>

						</ul>
					</div>


					<div class="multi_event_list">
						<ul>
							<li v-for='event in multidaysEvents'  :style='calculateWidth(event.dateStart,event.dateEnd, event.daysNum) '>
								 <OneEvent :event='event' :showTime='false' :longTitle='true'></OneEvent>
							</li>
						</ul>
					</div>


		
				</div>

			</div>

			<ScrollBarHorizontal></ScrollBarHorizontal>
		
		</div>

	</div>
</template>

<script>

	import store  from './CalendarStoreEvents'
	import moment from 'moment'
	import ScrollBarHorizontal from '../scrollbar/ScrollBarHorizontal'
	import scrollBus from '../scrollbar/ScrollBus';
	import OneEvent from './OneEvent'
	
	export default {
	  	name: 'calendar-week',
		data () {
		    return {
		    	date: null, 
		    	state: store.state, 
		    	events: store.state.events, 
		    	 wrapperId: '',
		    }
		}, 
		components: {
			ScrollBarHorizontal, OneEvent
		}, 
		created() {
            this.wrapperId = Math.random().toString(36).substring(7);
            scrollBus.$on('changeHorizontal', (msg) => {
                this.calculateBack(msg);
            });
        },
		mounted () {
			this.date = moment()
		},
		computed : {
			
			displayMonth(){
				return  moment(this.date).format('MMMM'); 
			},
			displayYear(){
				return  moment(this.date).format('YYYY'); 
			},
			displayWeek(){

				let weekNum =  moment(this.date).format('w'); 
				let currentWeek = moment().format('w'); 

				if(weekNum == currentWeek){
					return 'This week'
				}
				else{
					return 'Week #'+weekNum
				}
			},
			allWeek(){
				let startOfWeek = moment(this.date).startOf('isoWeek')
				let endOfWeek = moment(this.date).endOf('isoWeek')
				let days = []
				let day = startOfWeek

				while (day <= endOfWeek) {
				    days.push(day.toDate())
				    day = day.clone().add(1, 'd')
				}
				return days
			},

			multidaysEvents(){
				var startOfWeek = moment(this.date).startOf('isoWeek')
				var endOfWeek = moment(this.date).endOf('isoWeek')

				return store.filterByDayMultiple(this.state.events,startOfWeek, endOfWeek)
			}, 
			 holderWidth() {

			 	if(document.getElementById(this.wrapperId) ){
	                var full = document.getElementById(this.wrapperId).scrollWidth;
	                var client = document.getElementById(this.wrapperId).offsetWidth;
	                return full - client;
            	}
            },
		}, 
		methods : {
			prevWeek(){
				this.date = moment(this.date).add(-7, 'days')
			},
			nextWeek(){
				this.date = moment(this.date).add(7, 'days')
			},
			displayDayName(date){
				return moment(date).format('dddd'); 
			},
			displayDayNum(date){
				return moment(date).format('DD'); 
			}, 
			displayDayEvents(date){					
				return store.filterByDaySingle(this.state.events, date)
			}, 
			isToday(date){
			
				if( moment(date).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
					return true
				} 
			},
			calculateWidth(start, end, days){

				let dateStart = moment(start)
				let dateEnd = moment(end)
				let startWeek = moment(this.date).startOf('isoWeek')
				let width; 
				let paddingStart; 
				
				let totalDays = days
				let daysBefore = 0

			
			
				if(totalDays >= 7){
					width = 100; 
					paddingStart = 0; 
				}
				else{
					width = totalDays / 7 * 100

					daysBefore = startWeek.diff(dateStart, 'days')

					if(daysBefore < 0){
						daysBefore = Math.abs(daysBefore);
						paddingStart =  daysBefore / 7 * 100
					}

					else{
						paddingStart = 0; 
					}
				}

				return 'margin-left:'+paddingStart+'%; width: '+width+'%;'
			}, 
			 calculateBack(distPerc) {
                let posOfBar = (distPerc * this.holderWidth) / 100;
                document.getElementById(this.wrapperId).scrollLeft = posOfBar;
            },


            handleScroll(e){
				

				let width  = e.target.scrollWidth
				let scrollLeftMax = width - document.getElementById(this.wrapperId).offsetWidth;
			
				let topLeft = e.target.scrollLeft
			
				let percent =  (topLeft) * 100 / scrollLeftMax 

			

			
				scrollBus.$emit('scrollUpdateHorizontal', (percent) );

			}


		}, 
		updated (){
		
			document.getElementById(this.wrapperId).addEventListener('scroll', this.handleScroll);
	
		}, 
		
	}

</script>


// WEBPACK FOOTER //
// CalendarWeek.vue?1a9ff381